// @flow

import React from 'react'
import { markdown } from 'markdown'
import Appear from './Appear'
import Container from './Container'
import SectionTitle from './SectionTitle'

type FaqsItem = {
  id: string,
  related_id: string,
  language: string,
  title: string,
  text: string,
}

type Props = {
  title: string,
  items: Array<FaqsItem>
}

const Faqs = ({ title, items }: Props) => {
  return (
    <div className="bg-light-gray">
      <SectionTitle title={title} />
      <Appear>
        <Container className="pb-16">
        <div className="flex flex-col h-full shadow-xl">
          <div className="h-4 border-b-4 border-dashed border-light-gray bg-yellow" />
          <div key="content" className="flex-1 pt-6 pb-12 md:pb-8 bg-yellow">
            <ul
              key="list-container"
              className="px-5 text-base text-center md:text-lg md:pl-8 md:pr-24 md:text-left"
            >
              {items.map(item => (
                <Appear key={item.id}>
                  <li className="flex items-stretch justify-start">
                    <div key="item-bullet-container" className="items-start justify-start hidden py-1 mr-2 md:flex">
                      <div key="item-bullet" className="w-1 h-1 my-1 bg-orange" />
                    </div>
                    <div key="item-text-wrapper" className="mt-4 md:mt-0">
                      <h4 className="mb-1 text-base font-bold leading-tight md:text-lg md:mb-0">{item.title}</h4>
                      {item.text && 
                        <span className="flex-1 block mb-3 text-base font-light md:text-lg innerLinkYellow" dangerouslySetInnerHTML={{ __html: markdown.toHTML(item.text) }}/>
                      }
                    </div>
                  </li>
                </Appear>
              ))}
            </ul>
          </div>
        </div>
        </Container>
      </Appear>
    </div>
  )
}

export default Faqs
